import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import UsersApiV2 from 'api/v2/admins/users-api-v2'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select user by email, name, or phone.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const UserSelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()

  const [ searchUsers, setSearchUsers ]       = useState([])
  const [ isSearchLoading, setSearchLoading ] = useState(false)
  let userSearchTimeout                       = null

  // search user by email, name, or phone.
  const getUsers = (keyword) => {
    setSearchLoading(true)
    const additionalFilters = {
      q: keyword
    }
    UsersApiV2.get({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchUsers(response.data.users)
      })
      .catch(() => {
        setFieldError(name, 'Searching for User failed.')
        setFieldTouched(name, true, false)
      })
      .finally(() => setSearchLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.email }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.name }</span>
      <span className='mr-3'>{ `${option.phone === null ? '(No Phone Number)' :  `(${option.phone})` }` } </span>
    </>
  )

  // handler to search users
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (userSearchTimeout) clearTimeout(userSearchTimeout)
    userSearchTimeout = setTimeout(() => {
      getUsers(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search user by email, name, or phone.'
      dataList={ searchUsers }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

UserSelectSearchField.propTypes    = propTypes
UserSelectSearchField.defaultProps = defaultProps

export default UserSelectSearchField
